<h2 mat-dialog-title>{{data.predmet.nazov}}</h2>
<h3 mat-dialog-title class="text-black-50" i18n>Výber jazyka výúčby</h3>
<mat-dialog-content>
  <hr/>
  <div class="d-flex flex-row justify-content-around">
    <div *ngFor="let jazyk of data.predmet.jazyk">
      <button class="btn btn-lg btn-success" (click)="onSelect(jazyk)">{{jazyk}}</button>
    </div>
  </div>
</mat-dialog-content>
<hr/>
